import { render, staticRenderFns } from "./EstablishmentDeactivateModal.vue?vue&type=template&id=5920a3b7&scoped=true"
import script from "./EstablishmentDeactivateModal.vue?vue&type=script&lang=js"
export * from "./EstablishmentDeactivateModal.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentDeactivateModal.vue?vue&type=style&index=0&id=5920a3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920a3b7",
  null
  
)

export default component.exports